enum ROUTES {
  NOTIFICATIONS = '/notifications',
  NOTIFICATIONS_CENTER = '/notifications/center',
  NOTIFICATIONS_SETTINGS = '/notifications/settings',
}

export default ROUTES;
